import { PURCHASE_POINTS_LEGAL_NOTICE } from "@/features/purchasePoints/config/purchasePoints.config";

type PurchasePointsLegalNoticeProps = { className?: string };

export const PurchasePointsLegalNotice = ({ className = "" }: PurchasePointsLegalNoticeProps) => (
  <p
    className={`text-gray-500 dark:text-gray-400 text-sm ${className}`}
    data-testid="purchase-points-legal-notice"
  >
    {PURCHASE_POINTS_LEGAL_NOTICE}
  </p>
);

PurchasePointsLegalNotice.displayName = "PurchasePointsLegalNotice";
